export const SWIPE_REQUEST = 'SWIPE_REQUEST'
export const SWIPE_SUCCESS = 'SWIPE_SUCCESS'
export const SWIPE_FAILURE = 'SWIPE_FAILURE'

export const UNDO_SWIPE_REQUEST = 'UNDO_SWIPE_REQUEST'
export const UNDO_SWIPE_SUCCESS = 'UNDO_SWIPE_SUCCESS'
export const UNDO_SWIPE_FAILURE = 'UNDO_SWIPE_FAILURE'
